import axios from 'axios';

// Add a request interceptor
axios.interceptors.request.use(
   config => {
    // Do something before request is sent
    if (config.showLoading) {
      showFullScreenLoading()
    }
    let token = sessionStorage.getItem('token');
    if (token) {
      config.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
   error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    if (response.data.Type == 403) {
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('token');
      // Message.error('登录信息失效,稍后将自动为您转至登录页,请重新登录!');
      setTimeout(() => {
        location.href = '/login';
      }, 3000);
    } else if(response.data.Type == 500 || response.data.Type == 203){
      // Message.error("警告：" + response.data.Content);
    }
    return response;
  },
  (error) => {
    // Do something with response error
    return Promise.reject(error);
  }
);

const base = process.env.NODE_ENV === 'production' ? 'https://music.tiaopic.com/api' : 'http://127.0.0.1:7001/api';

export const uploadUrl = `${base}/public/upload`;

// 用户
export const requestLogin = params => { return axios.post(`${base}/user/login`, params).then(res => res.data); };

export const getUserInfo = params => { return axios.get(`${base}/user/info`, { params: params }); };

export const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };

export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };

export const addUser = params => { return axios.post(`${base}/user/add`, params); };

export const editUser = params => { return axios.post(`${base}/user/edit`, params); };

export const removeUser = params => { return axios.post(`${base}/user/remove`, params); };

export const batchRemoveUser = params => { return axios.post(`${base}/user/batchremove`, params); };

export const changePw = params => { return axios.post(`${base}/user/changepw`, params); };

// 分类
export const getCategoryList = params => { return axios.get(`${base}/category/list`, { params: params }); };

export const getCategoryListPage = params => { return axios.get(`${base}/category/listpage`, { params: params }); };

export const addCategory = params => { return axios.post(`${base}/category/add`, params); };

export const editCategory = params => { return axios.post(`${base}/category/edit`, params); };

export const removeCategory = params => { return axios.post(`${base}/category/remove`, params); };

export const batchRemoveCategory = params => { return axios.post(`${base}/category/batchremove`, params); };

// 歌手
export const getSingerList = params => { return axios.get(`${base}/singer/list`, { params: params }); };

export const getSingerListPage = params => { return axios.get(`${base}/singer/listpage`, { params: params }); };

export const addSinger = params => { return axios.post(`${base}/singer/add`, params); };

export const editSinger = params => { return axios.post(`${base}/singer/edit`, params); };

export const removeSinger = params => { return axios.post(`${base}/singer/remove`, params); };

export const batchRemoveSinger = params => { return axios.post(`${base}/singer/batchremove`, params); };


// 歌曲
export const getMusicList = params => { return axios.get(`${base}/music/list`, { params: params }); };

export const getMusicListPage = params => { return axios.get(`${base}/music/listpage`, { params: params }); };

export const addMusic = params => { return axios.post(`${base}/music/add`, params); };

export const editMusic = params => { return axios.post(`${base}/music/edit`, params); };

export const removeMusic = params => { return axios.post(`${base}/music/remove`, params); };

export const batchRemoveMusic = params => { return axios.post(`${base}/music/batchremove`, params); };


// 歌单
export const getAlbumListPage = params => { return axios.get(`${base}/album/listpage`, { params: params }); };

export const addAlbum = params => { return axios.post(`${base}/album/add`, params); };

export const editAlbum = params => { return axios.post(`${base}/album/edit`, params); };

export const removeAlbum = params => { return axios.post(`${base}/album/remove`, params); };

export const batchRemoveAlbum = params => { return axios.post(`${base}/album/batchremove`, params); };


// 歌单歌曲
export const getAlbumMusicListPage = params => { return axios.get(`${base}/albumMusic/listpage`, { params: params }); };

export const addAlbumMusic = params => { return axios.post(`${base}/albumMusic/add`, params); };

export const editAlbumMusic = params => { return axios.post(`${base}/albumMusic/edit`, params); };

export const removeAlbumMusic = params => { return axios.post(`${base}/albumMusic/remove`, params); };

export const batchRemoveAlbumMusic = params => { return axios.post(`${base}/albumMusic/batchremove`, params); };

// 版本
export const getVersionListPage = params => { return axios.get(`${base}/version/listpage`, { params: params }); };

export const addVersion = params => { return axios.post(`${base}/version/add`, params); };

export const editVersion = params => { return axios.post(`${base}/version/edit`, params); };

export const removeVersion = params => { return axios.post(`${base}/version/remove`, params); };

export const batchRemoveVersion = params => { return axios.post(`${base}/version/batchremove`, params); };


// WEBPACK FOOTER //
// ./src/api/api.js